import React from "react";
import { useUserContext } from "context/UserContext";
import VenuesBK from "layouts/BK/venues";
import { isBkLikeRole } from "utils/roleUtils";

function Venues() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <VenuesBK />;
  }
  return null;
}

export default Venues;
